import {ref} from 'vue';

export default {
    install: (app, options) => {
        const users = ref([]);

        const loadUsers = (url = '/dashboard/users') => {
            window.lazy_axios.get(url)
                .then((response) => {
                    users.value = response.data.users.data;
                });
        };

        app.provide('users', users);
        app.provide('loadUsers', loadUsers);

        app.provide('usersProvider', {
            users,
            loadUsers,
        });
    },
}
